export enum DomainRegistrationType {
    New = 'new',
    Transfer = 'transfer',
    Renewal = 'renewal',
    Trade = 'trade',
}
